import React from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import {
  TvBadge,
  TvButton,
  TvCard,
  TvCardBody,
  TvDiv,
  TvH1,
  TvH5,
  TvP,
  TvSmall,
} from "@trustvid/design-system";
import { useActiveAccountId } from "../../context/account-branding-context";
import { ROUTE_PATHS, toScopedRoute } from "../../routes/path-map";
import TvPremiumCrown from "./TvPremiumCrown";

/** Prototype 20-nav-module locked workspace card. */
const SaasModuleLock = ({ label, badge = "Premium", cta = "buyCredits" }) => {
  const navigate = useNavigate();
  const accountId = useActiveAccountId();
  const isPremiumBadge = String(badge).toLowerCase() === "premium";

  return (
    <TvCard className="tv-saas-module-lock" data-testid="saas-module-lock">
      <TvCardBody>
        {isPremiumBadge ? (
          <TvSmall className="tv-saas-module-lock__crown-wrap">
            <TvPremiumCrown title="Premium" size={18} />
            <span className="visually-hidden">Premium</span>
          </TvSmall>
        ) : (
          <TvBadge color="warning" className="tv-saas-module-lock__badge">
            {badge}
          </TvBadge>
        )}
        <TvH5 className="tv-saas-module-lock__title">Unlock {label}</TvH5>
        <TvP className="text-muted mb-3">
          This workspace opens when your plan includes {badge}.
        </TvP>
        <TvDiv className="d-flex flex-wrap gap-2">
          {cta === "buyCredits" ? (
            <TvButton
              type="button"
              color="primary"
              onClick={() => navigate(toScopedRoute(accountId, ROUTE_PATHS.buyCredits))}
            >
              Buy credits
            </TvButton>
          ) : null}
          <TvButton
            type="button"
            color="secondary"
            outline
            onClick={() => navigate(toScopedRoute(accountId, ROUTE_PATHS.dashboard))}
          >
            Home
          </TvButton>
        </TvDiv>
      </TvCardBody>
    </TvCard>
  );
};

export const SaasModuleChrome = ({ group, label, blurb, actions = null }) => (
  <TvDiv className="tv-saas-module__head">
    <TvDiv>
      {group ? <TvSmall className="tv-saas-dashboard__eyebrow">{group}</TvSmall> : null}
      <TvH1 className="tv-saas-dashboard__title">{label}</TvH1>
      {blurb ? <TvP className="tv-saas-dashboard__lead mb-0">{blurb}</TvP> : null}
    </TvDiv>
    {actions}
  </TvDiv>
);

export const SaasModuleFooter = () => {
  const accountId = useActiveAccountId();
  return (
    <TvDiv className="tv-saas-module__footer">
      <Link to={toScopedRoute(accountId, ROUTE_PATHS.dashboard)}>← Home</Link>
      {" · "}
      <Link to={toScopedRoute(accountId, ROUTE_PATHS.billing)}>Billing</Link>
    </TvDiv>
  );
};

SaasModuleLock.propTypes = {
  label: PropTypes.string.isRequired,
  badge: PropTypes.string,
  cta: PropTypes.oneOf(["buyCredits", "home"]),
};

SaasModuleChrome.propTypes = {
  group: PropTypes.string,
  label: PropTypes.string.isRequired,
  blurb: PropTypes.string,
  actions: PropTypes.node,
};

export default SaasModuleLock;
